import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, Skeleton, Typography } from '@mui/material';
import QuickLinkCard from './QuickLinkCard';

/** 4 cards per row from md breakpoint; 2 on sm; 1 on xs. */
const QUICK_LINK_GRID_PROPS = {
  xs: 12,
  sm: 6,
  md: 3,
  lg: 3,
  xl: 3,
};

export default function QuickLinkGrid({ links, isLoading, styles, onOpenLink }) {
  if (isLoading) {
    return (
      <Box sx={styles.quickLinksSection}>
        <Typography component="h2" sx={styles.sectionTitle}>
          Quick Links
        </Typography>
        <Grid container spacing={2.5} sx={styles.quickLinkGrid}>
          {Array.from({ length: 4 }).map((_, index) => (
            <Grid item {...QUICK_LINK_GRID_PROPS} key={`quick-link-skeleton-${index}`}>
              <Skeleton variant="rectangular" height={152} sx={{ borderRadius: 0 }} />
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }

  if (!links.length) {
    return (
      <Box sx={styles.quickLinksSection}>
        <Typography component="h2" sx={styles.sectionTitle}>
          Quick Links
        </Typography>
        <Box sx={styles.emptyState}>
          <Typography variant="body2">
            No modules are assigned to your account yet.
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={styles.quickLinksSection}>
      <Typography component="h2" sx={styles.sectionTitle}>
        Quick Links
      </Typography>
      <Grid container spacing={2.5} sx={styles.quickLinkGrid}>
        {links.map((link) => (
          <Grid item {...QUICK_LINK_GRID_PROPS} key={link.key}>
            <QuickLinkCard link={link} onOpen={onOpenLink} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

QuickLinkGrid.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      route: PropTypes.string.isRequired,
    })
  ),
  isLoading: PropTypes.bool,
  styles: PropTypes.object.isRequired,
  onOpenLink: PropTypes.func,
};
